import { CheckCircle, XCircle, RotateCcw, MapPin, Phone, Package, Printer } from "lucide-react";

const BonLivraisonDemo = () => {
  const tournee = {
    nom: "Tournée Samedi 1 Mars 2026",
    livreur: "Test User",
    date: "01/03/2026",
    heure_depart: "09h00",
    heure_fin: "13h45",
    distance: "127 km",
  };

  const livraisons = [
    { num: 1, nom: "Lydia Falize",       adresse: "Rue Joseph Weicker 27, 6740 Villers-sur-Semois", commande: "6x Master Noir",        prix: 210, encaisse: 210, statut: "livree",   heure: "09h45" },
    { num: 2, nom: "Julie Gruslin",      adresse: "Pré des Béguines 19, 6870 Saint-Hubert",          commande: "4x Master Beige",       prix: 140, encaisse: 140, statut: "livree",   heure: "10h20" },
    { num: 3, nom: "Client Anonyme",     adresse: "Clos du Bocage 4, 1410 Waterloo",                 commande: "8x Milan Transparent",  prix: 256, encaisse: 256, statut: "livree",   heure: "11h05" },
    { num: 4, nom: "Monika Passarelli",  adresse: "Akkerbouwstraat 61, 2170 Merksem",                commande: "4x Master Gris",        prix: 140, encaisse: 120, statut: "livree",   heure: "11h50", note: "Payé 120€ — manque 20€" },
    { num: 5, nom: "Julien Martin",      adresse: "Avenue des Combattants 45, 1340 Ottignies",       commande: "6x Milan Noir",         prix: 192, encaisse: 0,   statut: "reportee", heure: "12h30", note: "Client absent — reportée au 08/03" },
    { num: 6, nom: "Sophie Lambert",     adresse: "Rue Haute 88, 1000 Bruxelles",                    commande: "4x Master Rose",        prix: 140, encaisse: 140, statut: "livree",   heure: "13h10" },
    { num: 7, nom: "Karim El Mansouri",  adresse: "Chaussée de Louvain 212, 1030 Schaerbeek",        commande: "8x Milan Fumé",         prix: 256, encaisse: 256, statut: "livree",   heure: "13h40" },
  ];

  const livrees   = livraisons.filter(l => l.statut === "livree");
  const reportees = livraisons.filter(l => l.statut === "reportee");
  const totalPrevu    = livraisons.reduce((s, l) => s + l.prix, 0);
  const totalEncaisse = livrees.reduce((s, l) => s + l.encaisse, 0);
  const ecart = totalEncaisse - totalPrevu + reportees.reduce((s, l) => s + l.prix, 0);

  return (
    <div className="min-h-screen bg-slate-100 p-4 font-sans">
      <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">

        {/* Header */}
        <div className="bg-indigo-600 px-6 py-5">
          <div className="flex items-start justify-between">
            <div>
              <h1 className="text-white font-bold text-xl">Bon de tournée</h1>
              <p className="text-indigo-200 text-sm mt-0.5">{tournee.nom}</p>
            </div>
            <div className="text-right text-indigo-200 text-sm space-y-0.5">
              <p>Livreur : <span className="text-white font-medium">{tournee.livreur}</span></p>
              <p>Départ : {tournee.heure_depart} — Fin : {tournee.heure_fin}</p>
              <p>Distance : {tournee.distance}</p>
            </div>
          </div>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-4 divide-x border-b">
          {[
            { label: "Livraisons", value: `${livrees.length}/${livraisons.length}`, color: "text-green-600" },
            { label: "Reportées",  value: reportees.length,                         color: "text-orange-500" },
            { label: "Prévu",      value: `${totalPrevu} €`,                        color: "text-slate-700" },
            { label: "Encaissé",   value: `${totalEncaisse} €`,                     color: "text-indigo-600" },
          ].map((kpi) => (
            <div key={kpi.label} className="p-4 text-center">
              <p className={`font-bold text-xl ${kpi.color}`}>{kpi.value}</p>
              <p className="text-slate-400 text-xs mt-0.5">{kpi.label}</p>
            </div>
          ))}
        </div>

        {/* Livraisons list */}
        <div className="divide-y">
          {livraisons.map((l) => (
            <div key={l.num} className={`px-6 py-4 ${l.statut === "reportee" ? "bg-orange-50" : ""}`}>
              <div className="flex items-start gap-3">
                {/* Numéro + icône */}
                <div className="flex flex-col items-center gap-1 flex-shrink-0">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white font-bold text-sm ${
                    l.statut === "livree" ? "bg-green-500" : "bg-orange-400"
                  }`}>
                    {l.num}
                  </div>
                  {l.statut === "livree"
                    ? <CheckCircle className="w-4 h-4 text-green-500" />
                    : <RotateCcw className="w-4 h-4 text-orange-400" />
                  }
                </div>

                {/* Infos client */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <p className="font-semibold text-slate-800">{l.nom}</p>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                      l.statut === "livree" ? "bg-green-100 text-green-700" : "bg-orange-100 text-orange-700"
                    }`}>
                      {l.statut === "livree" ? "LIVRÉ" : "REPORTÉE"}
                    </span>
                  </div>
                  <p className="text-slate-500 text-sm flex items-center gap-1 mt-0.5">
                    <MapPin className="w-3 h-3 flex-shrink-0" />{l.adresse}
                  </p>
                  <div className="flex items-center justify-between mt-1">
                    <p className="text-slate-600 text-sm flex items-center gap-1">
                      <Package className="w-3 h-3" />{l.commande}
                    </p>
                    <p className="text-sm font-medium text-slate-700">
                      {l.statut === "livree"
                        ? <span className={l.encaisse !== l.prix ? "text-orange-600" : "text-green-600"}>
                            {l.encaisse} € encaissé
                          </span>
                        : <span className="text-orange-500">— € (non encaissé)</span>
                      }
                    </p>
                  </div>
                  {l.note && (
                    <p className="text-xs text-slate-500 italic mt-1 bg-slate-50 rounded px-2 py-1">
                      Note : {l.note}
                    </p>
                  )}
                  <p className="text-xs text-slate-400 mt-1">Passage : {l.heure}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer summary */}
        <div className="bg-slate-50 border-t px-6 py-5 space-y-2">
          <p className="font-bold text-slate-700 text-sm mb-3">Récapitulatif financier</p>
          <div className="flex justify-between text-sm">
            <span className="text-slate-500">Total prévu</span>
            <span className="font-medium text-slate-700">{totalPrevu} €</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-slate-500">Non encaissé (reportées)</span>
            <span className="font-medium text-orange-500">- {reportees.reduce((s,l) => s+l.prix,0)} €</span>
          </div>
          <div className="h-px bg-slate-200 my-1" />
          <div className="flex justify-between text-base font-bold">
            <span className="text-slate-700">Total encaissé</span>
            <span className="text-indigo-600">{totalEncaisse} €</span>
          </div>
          {ecart !== 0 && (
            <div className="flex justify-between text-sm">
              <span className="text-slate-500">Écart (paiements partiels)</span>
              <span className={ecart < 0 ? "text-red-500 font-medium" : "text-green-500 font-medium"}>{ecart > 0 ? "+" : ""}{ecart} €</span>
            </div>
          )}
        </div>

        {/* Print button */}
        <div className="px-6 py-4 flex gap-3 border-t">
          <button className="flex-1 flex items-center justify-center gap-2 py-3 bg-indigo-600 text-white rounded-xl font-medium hover:bg-indigo-700 transition-colors">
            <Printer className="w-4 h-4" />
            Imprimer / Télécharger PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default BonLivraisonDemo;
